/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_ASSET_DETAIL } from "../pages/ListedAssetDetail/graphql/listed-asset-detail.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

const MODULE_NAME = "ListedAssetDetailService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ListedAssetDetailService {
    private static instance: ListedAssetDetailService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): ListedAssetDetailService {
        if (!ListedAssetDetailService.instance) {
            ListedAssetDetailService.instance = new ListedAssetDetailService(props);
        }
        return ListedAssetDetailService.instance;
    }

    // async getListedAssetDetail(assetId: string, assetGroup: string) {
    //     const graphqlModule = getGraphQLModule();
    //     const client = graphqlModule.getClient("graphql-gateway");
    //     try {
    //         if (client) {
    //             const res = await client.query({
    //                 query: GET_ASSET_DETAIL,
    //                 variables: {
    //                     getAssetDetailsAssetId: assetId,
    //                     getAssetDetailsAssetGroup: assetGroup,
    //                 },
    //                 fetchPolicy:'network-only'
    //             });
    //             log.success(MODULE_NAME, "getListedAssetDetail: ", res);
    //             if (res?.data?.getAssetDetails?.tabsItems) {
    //                 try {
    //                     // Parse a JSON
    //                     res.data.getAssetDetails.tabsItems = JSON.parse(res?.data?.getAssetDetails?.tabsItems);
    //                 } catch (e) {
    //                     // You can read e for more info
    //                 }
    //             }
    //             return res?.data?.getAssetDetails;
    //         }
    //     } catch (err) {
    //     }
    // }

    async getListedAssetDetail(assetId: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId:assetId,
                        storeId:"61739cbd2fbe0a187c984fb6"
                    },
                });
                if(res){
                    let _data = res?.data?.getAsset
                    let _found ={
                        idx: _data?.idx,
                        title: _data?.title,
                        subtitle: _data?.subtitle,
                        serialNo: _data?.serialNo,
                        tag: 'GOLD',
                        category: 'gold',
                        price: _data?.price,
                        meta: _data?.attrs?.map((item:any)=>{
                            return({
                                key:item?.name,
                                value: item?.val,
                                disp_type:item?.disp_type
                            })
                        }),
                        buttons: [
                            // {
                            //     key: "buyNowFiat",
                            //     title: "Buy in USD"
                            // },
                            // {
                            //     key: "buyNowCrypto",
                            //     title: "Buy in ETH"
                            // }
                            // {
                            //     key:"mint",
                            //     title:"Mint"
                            // },
                            // {
                            //     key:"edit",
                            //     title:"Edit"
                            // }
                        ],
                        images: _data?.media?.map((item:any)=>{
                            return({
                                // ...item,
                                original:item?.src,
                                thumbnail:item?.src,
                                thumbnailHeight: "70",
                                thumbnailClass:"image-thumb"
                            })
                        }),
                        // timeline: _data?.timeline?.map((item:any)=>{
                        //     return({
                        //         title: item?.event,
                        //         description:[
                        //             // {
                        //             //     displayType: "date",
                        //             //     key: "Listed At",
                        //             //     value: item?.date?.toISOString()
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "From",
                        //             //     value: item?.from?.value,
                        //             //     link: item?.from?.link
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "To",
                        //             //     value: item?.to?.value,
                        //             //     link: item?.to?.link
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "Proof of List",
                        //             //     value: item?.proof?.value,
                        //             //     link: item?.proof?.link
                        //             // }
                        //         ]
                        //     })
                        // }),
                    }
                if(_found){
                    return _found;
                }
                
                }
                // log.success(SERVICE_NAME, "get asset detail result: ", res);
                // // return res?.data?.getAssets;
                // return res?.data?.getAsset;
            }
        } catch (err) {
            return err;
        }
    }
}
